import { UnsupportedChainIdError } from "@web3-react/core";
import {
  NoEthereumProviderError,
  UserRejectedRequestError as UserRejectedRequestErrorInjected,
} from "@web3-react/injected-connector";
import {
  NoEthereumProviderError as NoEthereumProviderErrorCustom,
  UserRejectedRequestError as UserRejectedRequestErrorCustom,
} from "connectors/common";
import { UserRejectedRequestError as UserRejectedRequestErrorWalletConnect } from "@web3-react/walletconnect-connector";

export const getErrorMessage = (error: Error) => {
  if (
    error instanceof NoEthereumProviderError ||
    error instanceof NoEthereumProviderErrorCustom
  ) {
    return "Wallet extension not found in the browser.";
  } else if (error instanceof UnsupportedChainIdError) {
    return "Matic staking is supported on Ethereum and Polygon Network.";
  } else if (
    error instanceof UserRejectedRequestErrorInjected ||
    error instanceof UserRejectedRequestErrorWalletConnect ||
    error instanceof UserRejectedRequestErrorCustom
  ) {
    return "Please authorize Stader Labs to access your wallet account.";
  } else if (
    error.message &&
    [
      "metamask tx signature: user denied transaction signature.",
      "tx signature: user denied transaction signature.",
      "user rejected the transaction",
      "User canceled",
    ].includes(error.message.toLowerCase())
  ) {
    return "User denied transaction.";
  } else if (error.name === "TransportStatusError") {
    return error.message;
  } else {
    return "An unknown error occurred.";
  }
};
